import React from 'react';
import { ActivityIcon, AlertTriangleIcon, InfoIcon, PauseIcon, RepeatIcon, TargetIcon } from 'lucide-react';
import type { EventCategory, TeamSide } from './gameTimelineData';
export const categoryIcon = (category: EventCategory, className = 'w-3.5 h-3.5') => {
  switch (category) {
    case 'point':
      return <TargetIcon className={className} aria-hidden="true" data-id="element-114" data-mp="l53f5r9no5rj" />;
    case 'foul':
      return <AlertTriangleIcon className={className} aria-hidden="true" data-id="element-115" data-mp="q1k4upwi6s6q" />;
    case 'turnover':
      return <RepeatIcon className={className} aria-hidden="true" data-id="element-116" data-mp="v0n9i98kmwe6" />;
    case 'timeout':
      return <PauseIcon className={className} aria-hidden="true" data-id="element-117" data-mp="100jd47dcwlt7" />;
    case 'injury':
      return <ActivityIcon className={className} aria-hidden="true" data-id="element-118" data-mp="1424plrlzay2v" />;
    default:
      return <InfoIcon className={className} aria-hidden="true" data-id="element-119" data-mp="31s5xhq2qtigp" />;
  }
};
export const categoryChipClasses: Record<EventCategory, string> = {
  point: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  foul: 'bg-amber-50 text-amber-700 border-amber-200',
  turnover: 'bg-orange-50 text-orange-700 border-orange-200',
  timeout: 'bg-sky-50 text-sky-700 border-sky-200',
  injury: 'bg-rose-50 text-rose-700 border-rose-200',
  general: 'bg-gray-50 text-gray-700 border-gray-200'
};
export const teamAccent = (team: TeamSide) => {
  switch (team) {
    case 'home':
      return {
        text: 'text-red-600',
        border: 'border-red-500',
        soft: 'bg-red-50',
        dot: 'bg-red-500'
      };
    case 'away':
      return {
        text: 'text-blue-600',
        border: 'border-blue-500',
        soft: 'bg-blue-50',
        dot: 'bg-blue-500'
      };
    default:
      return {
        text: 'text-gray-600',
        border: 'border-gray-400',
        soft: 'bg-gray-50',
        dot: 'bg-gray-400'
      };
  }
};